module.exports = __webpack_public_path__ + "static/media/t41.32179820.jpg";